import { createStandardAction } from "typesafe-actions";

import { IFile } from "../../interfaces/File";
import { FileActionTypes } from "./constants";

export const setFile = createStandardAction(FileActionTypes.SET_FILE)<IFile | null>();
